import * as React from 'react';
import { Experiment, ExperimentControl, ExperimentVariant } from '@shared-ui/experiment-context';
import { SharedUiPropertySpacesWrapper } from '../shared-ui/details/property-spaces-wrapper';
import { SpaceDetailsWrapper } from '../template-components/space-details-wrapper';
export const PropertySpacesExperiment = () => React.createElement(Experiment, {
  name: "Vrbex_SUVR_Spaces"
}, React.createElement(ExperimentControl, null, React.createElement(SpaceDetailsWrapper, null)), React.createElement(ExperimentVariant, {
  bucket: 1
}, React.createElement(SharedUiPropertySpacesWrapper, null)));